// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './ECartItemContent.module.scss';;


type Props = {
  children: React.Node,
  className?: string,
  htmlFor?: string,
}

const ECartItemContent = ({ children, className, htmlFor }: Props) => (
  <div className={classNames(styles.root, className)}>
    {children}
    {htmlFor
      && <label // eslint-disable-line jsx-a11y/label-has-associated-control
        className={styles.label}
        htmlFor={htmlFor}
      />}
  </div>
);

export default ECartItemContent;
